import React from 'react'
import './MediaUpload.css'

/**
 * 미디어 업로드 드롭존 컴포넌트
 */
function MediaUpload({ section, onFileUpload, onFileDrop }) {
  const handleFileChange = async (e) => {
    const file = e.target.files[0]
    if (file) {
      // 파일 확장자 체크
      const fileName = file.name.toLowerCase()
      const isVideoByExt = fileName.endsWith('.mp4') || fileName.endsWith('.webm') || 
                          fileName.endsWith('.avi') || fileName.endsWith('.mov')
      const isImageByExt = fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || 
                          fileName.endsWith('.png') || fileName.endsWith('.gif') || 
                          fileName.endsWith('.webp')
      
      console.log('📁 파일 선택됨:', {
        name: file.name,
        size: file.size,
        type: file.type || 'unknown',
        isImage: file.type.startsWith('image/') || isImageByExt,
        isVideo: file.type.startsWith('video/') || isVideoByExt,
        extension: fileName.split('.').pop()
      })
      
      // 파일 타입 체크 (MIME 타입 또는 확장자로 체크)
      const isValid = file.type.startsWith('image/') || file.type.startsWith('video/') || 
                     isImageByExt || isVideoByExt
      
      if (!isValid) {
        console.error('❌ 지원하지 않는 파일:', { type: file.type, name: file.name })
        // alert 제거 - 콘솔에만 오류 표시
        return
      }
      
      try {
        console.log('🚀 onFileUpload 호출 전')
        await onFileUpload(section.id, file)
        console.log('✅ 파일 업로드 완료')
      } catch (error) {
        console.error('❌ 파일 업로드 실패:', error)
        // alert 제거 - 콘솔에만 오류 표시
      }
    } else {
      console.log('⚠️ 파일이 선택되지 않음')
    }
  }

  // 드래그 오버 핸들러
  const handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'copy'
  }

  // 전체 영역 클릭 핸들러
  const handleZoneClick = () => {
    document.getElementById(`media-${section.id}`).click()
  }

  return (
    <div 
      className="drop-zone"
      onDragOver={handleDragOver}
      onDrop={(e) => {
        e.preventDefault()  // 기본 동작 방지
        e.stopPropagation()  // 상위 요소로 이벤트 전파 방지
        onFileDrop(e, section.id, 'image')
      }}
      onClick={handleZoneClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="drop-icon">
        <svg
          aria-hidden="true"
          className="e-font-icon-svg e-far-image"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '14px', height: '14px', fill: '#a5a5a5', paddingRight: '6px' }}
        >
          <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"></path>
        </svg>
      </div>
      <p style={{ color: '#a5a5a5', fontSize: '12px', paddingBottom: '5px' }}>이미지 &amp; 비디오 드래그 업로드</p>

      <input
        type="file"
        accept="image/*,video/*"
        onChange={handleFileChange}
        className="file-input-hidden"
        id={`media-${section.id}`}
        style={{ display: 'none' }}
      />
    </div>
  )
}

export default MediaUpload